export default __webpack_public_path__ + "static/media/credit-card-icon.f2b2fa42.svg";